<template>
  <b-modal
    :id="id"
    :title="trans('message_preview')"
    size="lg"
    @shown="onShown"
    @hidden="onHidden"
  >
    <b-row>
      <b-col md="6" lg="7" style="min-height: 400px;">
        <b-form-group v-if="sendOut.type == 'both'" class="mb-3">
          <b-form-radio-group
            buttons
            button-variant="outline-primary"
            v-model="preview"
            :options="types"
            class="mr-2"
          />
        </b-form-group>

        <list-recipients v-if="sendOut.recipient_list_id"
          :organization="organization"
          :list_id="sendOut.recipient_list_id"
          @recipient="recipient = $event"
          @placeholders="placeholders = $event"
        ></list-recipients>
        <p v-if="!sendOut.recipient_list_id">
          <strong>{{ trans('recipient') }}</strong>
          <span v-if="recipientName" class="d-block">
            {{ recipientName }}
          </span>
          <span v-if="sendOut.to_email" class="d-block">
            {{ sendOut.to_email }}
          </span>
          <span v-if="sendOut.to_mobile" class="d-block">
            {{ formatPhone(sendOut.to_mobile) }}
          </span>
        </p>
      </b-col>
      <b-col md="6" lg="4" style="overflow: hidden;">
        <div id="preview" ref="preview">
          <div id="sms_preview" v-if="preview == 'sms'">
            <img class="iphone-x" src="/img/frontend/iphone-x-message.png" />
            <div class="chat">
              <div class="yours messages">
                <div class="message last" v-html="message"></div>
              </div>
            </div>
          </div>
          <div id="email_preview" v-if="preview == 'email'">
            <img class="iphone-x" src="/img/frontend/iphone-x-email.png" style="z-index:200;pointer-events:none;" />
            <iframe
              v-if="ready && emailPreviewUrl"
              frameborder="0"
              :width="320"
              :height="435"
              :src="emailPreviewUrl"
              :style="`
                position: absolute;
                z-index: 100;
                margin-top: ${emailPreviewMarginY}px;
                margin-left: ${emailPreviewMarginX}px;
                -ms-transform: scale(${emailPreviewScale});
                -moz-transform: scale(${emailPreviewScale});
                -o-transform: scale(${emailPreviewScale});
                -webkit-transform: scale(${emailPreviewScale});
                transform: scale(${emailPreviewScale});
                -ms-transform-origin: 0 0;
                -moz-transform-origin: 0 0;
                -o-transform-origin: 0 0;
                -webkit-transform-origin: 0 0;
                transform-origin: 0 0;`"
            ></iframe>
          </div>
        </div>
      </b-col>
    </b-row>
    <template v-slot:modal-footer>
      <b-row class="w-100">
        <b-col>
        </b-col>
        <b-col class="col-auto">
          <b-button variant="secondary" @click="$bvModal.hide(id)">
            {{ trans('close') }}
          </b-button>
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<script>
  import ListRecipients from './../list/ListRecipients'

  export default {
    props: {
      id: {
        type: String,
        default: 'message-preview-modal',
      },
      organization: Object,
      sendOut: Object,
      presetPreviewUrl: String,
    },
    components: {
      ListRecipients,
    },
    data() {
      return {
        trans: trans,
        formatPhone: _.formatPhone,
        busy: false,
        error: null,
        recipient: null,
        preview: this.sendOut.type == 'both' ? 'email' : this.sendOut.type, // sms or email
        emailPreviewUrl: null,
        emailPreviewFullWidth: null,
        types: [{
          value: 'sms',
          text: trans('sms'),
        }, {
          value: 'email',
          text: trans('email'),
        }],
        ready: false,
        placeholders: null,
      }
    },
    computed: {
      recipientName() {
        return this.sendOut.name != this.sendOut.to_email && this.sendOut.name != this.sendOut.to_mobile ? this.sendOut.name : ''
      },
      message() {
        let recipient = this.recipient || {
          name: this.recipientName,
          email: this.sendOut.to_email,
          mobile: this.sendOut.to_mobile,
          extra: {},
        }
        let body = _.replacePlaceholders(this.sendOut.body, this.placeholders)

        let links = this.getLinksString(this.sendOut.body)

        let message = _.ckeditorHtmlToText(body).substr(0, 290).replace('\n', '<br/>')
        /*if (this.sendOut.media_url)
          message = `<img src="${this.sendOut.media_url}" style="max-width:100%;" /><br/>` + message*/

        if (!!this.sendOut.shortened_url ||
          !!this.sendOut.template_id ||
          !!this.sendOut.media_url ||
          links.length > 0 ||
          body.length > 290)
          message += `<br/><a href="${this.sendOut.shortened_url || '#'}" target="_blank" onclick="event.preventDefault()">${this.sendOut.shortened_url || 'https://am.lol/xxxxxxx'}</a>`

        return message
      },
      emailPreviewMarginY() {
        return this.emailPreviewFullWidth * 0.31
      },
      emailPreviewMarginX() {
        return this.emailPreviewFullWidth * 0.075
      },
      emailPreviewWidth() {
        return this.emailPreviewFullWidth - this.emailPreviewMarginX * 2
      },
      emailPreviewHeight() {
        return this.emailPreviewFullWidth
      },
      emailPreviewScale() {
        return this.emailPreviewWidth / 320
      },
      emailPreviewBaseUrl() {
        return this.presetPreviewUrl ||
          `/organization/${this.organization.id}/sendout/${this.sendOut.id}/scheduled_email_preview`
      },
    },
    watch: {
      recipient() {
        let url = this.emailPreviewBaseUrl + '/' + (this.recipient ? this.recipient.id : '')
        if (this.emailPreviewUrl != url) this.emailPreviewUrl = url

        if (this.preview == 'email') {
          if (this.ready == false)
            setTimeout(() => {
              this.ready = true
              if (!this.emailPreviewFullWidth) this.handleResize()
            }, 1)
        }
      },
      preview() {
        if (this.preview == 'email') {
          if (this.ready == false)
            setTimeout(() => {
              this.ready = true
              if (!this.emailPreviewFullWidth) this.handleResize()
            }, 1)
        } else {
          this.ready = false
        }
      },
      presetPreviewUrl() {
        this.emailPreviewUrl = this.emailPreviewBaseUrl + '/' + (this.recipient ? this.recipient.id : '')
      },
    },
    methods: {
      getLinksString(htmlString) {
        let linkRegex = /<a\s+(?:[^>]*?\s+)?href="([^"]*)"/g
        var links = []
        var match

        // Use the regex to find all matches in the string
        while ((match = linkRegex.exec(htmlString)) !== null) {
            // The href value is in the first capturing group
            links.push(match[1]);
        }
        return links
      },
      handleScroll() {
        if (!this.ready) return
        let $preview = $('#preview')
        let $parent = $preview.parent()
        let $img = $preview.find('img')

        let t = Math.max(0, window.scrollY - $parent.offset().top + 10)
        t -= Math.max(0, t + $img.outerHeight() - $parent.outerHeight())
        if (t < 0 ) t = 0

        $preview.css('margin-top', t + 'px')
      },
      handleResize() {
        if (this.$refs.preview)
          this.emailPreviewFullWidth = this.$refs.preview.clientWidth        
      },
      onHidden() {
        this.ready = false
        this.recipient = null
      },
      onShown() {
        this.preview = this.sendOut.type == 'both' ? 'email' : this.sendOut.type
        if (!this.emailPreviewUrl) this.emailPreviewUrl = this.emailPreviewBaseUrl
        if (!this.emailPreviewFullWidth) this.handleResize()
        if (this.preview == 'email' && !this.sendOut.recipient_list_id) this.ready = true
      },
    },
    mounted() {
      window.sendOutPreview = this
    },
    created () {
      window.addEventListener('scroll', this.handleScroll)
      window.addEventListener('resize', this.handleResize)
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
      window.removeEventListener('resize', this.handleResize)
    },
  }
</script>